import {withStyles} from '@material-ui/core/styles'
import {ToggleButton} from '@material-ui/lab'

import {theme} from '../theme'

export default withStyles(
  {
    root: {
      border: '0 none',
      padding: '15px 20px',
      flex: 1,
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      textAlign: 'initial',
      color: theme.palette.common.black,
      opacity: 0.5,
      '&$selected': {
        opacity: 1,
        boxShadow: '0 8px 20px rgba(117, 115, 111, 0.2)',
        backgroundColor: theme.palette.common.white,
        color: theme.palette.secondary.main,
      },
      '&$disabled': {
        boxShadow: 'none',
        opacity: 0.25,
        color: theme.palette.secondary.main,
      },
      '&:hover': {
        backgroundColor: theme.palette.grey[300],
      },
    },
    selected: {},
    disabled: {},
  },
  {name: 'LPCTogglePlate'},
)(ToggleButton)
